<template>
	<transition name="v2-modal-transition">
		<div class="v2r-modal-overlay" @click.self="close">
			<div class="v2r-modal">
				<div class="v2r-modal__head">
					<div class="v2r-modal__icon v2r-modal__icon--red">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
					</div>
					<div>
						<div class="v2r-modal__title">{{ $t('campaign.reject_request_title') || 'Reject request' }}</div>
						<div class="v2r-modal__sub">{{ $t('campaign.reject_request_sub') || 'Provide feedback so the DSP can fix and resubmit' }}</div>
					</div>
				</div>
				<div class="v2r-modal__body">
					<div class="v2r-reason">
						<textarea
							v-model="reason"
							class="v2r-reason__input"
							:placeholder="$t('campaign.reject_reason_placeholder') || 'Describe what needs to change…'"
						/>
						<div class="v2r-reason__chips">
							<button
								v-for="chip in chips"
								:key="chip.key"
								type="button"
								class="v2r-reason__chip"
								:class="{ 'v2r-reason__chip--on': selectedChips.includes(chip.key) }"
								@click="toggleChip(chip.key)"
							>{{ chip.label }}</button>
						</div>
						<div class="v2r-reason__required"><b>*</b> {{ $t('campaign.reject_reason_required') || 'A reason is required before confirming rejection.' }}</div>
					</div>
				</div>
				<div class="v2r-modal__foot">
					<button class="v2r-modal__btn v2r-modal__btn--outline" @click="close">
						{{ $t('cancel') | capitalize }}
					</button>
					<button
						class="v2r-modal__btn v2r-modal__btn--reject"
						:disabled="!canConfirm"
						@click="confirm"
					>
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
						{{ $t('campaign.confirm_reject') || 'Confirm Reject' }}
					</button>
				</div>
			</div>
		</div>
	</transition>
</template>


<script>
export default {
	name: 'V2RejectWithReasonModal',

	data() {
		return {
			reason: '',
			selectedChips: [],
		};
	},

	computed: {
		chips() {
			return [
				{ key: 'inappropriate', label: this.$t('campaign.reject_chip_inappropriate') || 'Inappropriate content' },
				{ key: 'wrong_format', label: this.$t('campaign.reject_chip_wrong_format') || 'Wrong format' },
				{ key: 'budget_too_low', label: this.$t('campaign.reject_chip_budget_too_low') || 'Budget too low' },
				{ key: 'pricing_unsupported', label: this.$t('campaign.reject_chip_pricing_unsupported') || 'Pricing model unsupported' },
				{ key: 'other', label: this.$t('campaign.reject_chip_other') || 'Other' },
			];
		},

		canConfirm() {
			return (this.reason && this.reason.trim().length > 0) || this.selectedChips.length > 0;
		},
	},

	methods: {
		close() {
			this.$emit('close');
		},

		toggleChip(key) {
			const idx = this.selectedChips.indexOf(key);
			if (idx === -1) {
				this.selectedChips.push(key);
			} else {
				this.selectedChips.splice(idx, 1);
			}
		},

		confirm() {
			if (!this.canConfirm) return;
			this.$emit('confirm', {
				reason: this.reason.trim(),
				chips: this.selectedChips.slice(),
			});
		},
	},
};
</script>


<style lang="sass" scoped>
@import '~@/assets/styles/v2-tokens.sass'
@import './modal-shared'
</style>
